/* SET STATE */
export const SET_STATE_LAB = "SET_STATE_LAB"

/* LABS */
export const GET_LABS = "GET_LABS"
export const GET_LABS_SUCCESS = "GET_LABS_SUCCESS"
export const GET_LABS_FAIL = "GET_LABS_FAIL"

/* LAB */
export const GET_LAB = "GET_LAB"
export const GET_LAB_SUCCESS = "GET_LAB_SUCCESS"
export const GET_LAB_FAIL = "GET_LAB_FAIL"

/**
 * ADD LAB
 */
 export const ADD_NEW_LAB = "ADD_NEW_LAB"
 export const ADD_LAB_SUCCESS = "ADD_LAB_SUCCESS"
 export const ADD_LAB_FAIL = "ADD_LAB_FAIL"

 /**
 * UPDATE LAB
 */
export const UPDATE_LAB = "UPDATE_LAB"
export const UPDATE_LAB_STATUS = "UPDATE_LAB_STATUS"
export const UPDATE_LAB_SUCCESS = "UPDATE_LAB_SUCCESS"
export const UPDATE_LAB_FAIL = "UPDATE_LAB_FAIL"

/**
 * DELETE LAB
 */
export const DELETE_LAB = "DELETE_LAB"
export const DELETE_LAB_SUCCESS = "DELETE_LAB_SUCCESS"
export const DELETE_LAB_FAIL = "DELETE_LAB_FAIL"
